import GlobalStore from "./globalStore";

const store = new GlobalStore();

export default store;
